//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Drawings/Drawings.SelectDraftingViewList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ExistingAutomaticAnnotation",1,0],[0,"IsCreateContinuitySymbolForBoundingStructureOfBracket",1,0],[0,"IsCreateContinuitySymbolOnSectionStiffener",1,0],[0,"IsCreateFireAndSafetyPlan",1,0],[0,"IsCreateOpeningFillLines",1,0],[0,"IsCreateReferenceLines",1,0],[0,"IsCreateScantling",1,0],[0,"IsCreateScantlingTable",1,0],[0,"IsCreateStiffenerSectionSymbol",1,0],[0,"IsCreateStructureID",1,0],[0,"ShowDefaultGradeInScantlingTable",1,1],[1,"ViewList",0,"Drawings.SelectDraftingViewList",0]],[[["defaultGrades"],"UpdateDefaultGrades",{},1,0],[["strExcessMaterialTypes"],"SetSelectedExcessMatrialTypes",{},1,0]],[]];
SPLM.Features.ShipDesign.DrawingAnnotationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.DrawingAnnotationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.DrawingAnnotationBuilder.Annotation = Object.freeze({
    "Preserve" : "Preserve", "Delete" : "Delete"});

export default SPLM;